<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Personal con armamento</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <BaseInput v-model="search" label="Buscar" append-icon="mdi-magnify" style="max-width: 300px" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="personalOriginal" class="transparent">
                  <template v-slot:[`item.nombre`]="{ item }">
                    {{ item.nombreCompleto }}
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    {{ item.puesto ? item.puesto : '' }}
                  </template>
                  <template v-slot:[`item.CUP`]="{ item }">
                    <span>
                      {{ item.CUP ? item.CUP : 'Sin datos' }}
                    </span>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-card-account-details-outline"
                              :to="{
                                path: 'documentos_personal/' + item.id_personal,
                                params: { id: item.id_personal },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-delete-alert-outline"
                              @click="openRemoverLocDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Eliminar personal LOC</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              elevation="8"
                              variant="secondary"
                              icon="mdi-file-word"
                              @click="generarConstanciaNoAdeudo(item)"
                            />
                          </span>
                        </template>
                        <span>Constancia de No Adeudo</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              elevation="8"
                              variant="secondary"
                              icon="mdi-file-word-outline"
                              @click="generarResguardoArmamentoMuniciones(item)"
                            />
                          </span>
                        </template>
                        <span>Constancia de Resguardo</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { Packer } from 'docx'
import IconButton from '../../base/IconButton.vue'
import BaseInput from '../../base/BaseInput.vue'
import TextButton from '../../base/TextButton.vue'
import moment from 'moment'
import ConstanciaNoAdeudoArmeria from '@src/utils/doc-generator/armeria/ConstanciaNoAdeudo.js'
import ResguardoArmamentoMuniciones from '@src/utils/doc-generator/armeria/ResguardoArmamentoMuniciones.js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: {
    IconButton,
    BaseInput,
    TextButton,
  },

  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombre', width: '250px' },
        { text: 'Puesto', value: 'puesto', width: '200px' },
        { text: 'CUIP', value: 'CUIP', width: '150px' },
        { text: 'CUP', value: 'CUP', width: '100px' },
        { text: 'Remesa', value: 'remesa', width: '100px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '150px' },
      ],
      loading: false,
      search: '',
      mostrarConstancia: false,
      resguardoArmamentoMuniciones: false,
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('armeria', {
      personalOriginal: 'getPersonalArmas',
    }),
    ...mapGetters('armaPersonal', {
      armas: 'getArmasPersonal',
    }),
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('armeria', ['removePersonalLoc']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),

    openRemoverLocDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.CONFIRMACION_REMOVER_PERSONAL_LOC,
        props: {
          idPersonal: item.id_personal,
          idPersonalLoc: item.idPersonalLoc,
          onConfirm: () => this.confirmRemoveLoc(item),
        },
      })
    },

    async confirmRemoveLoc(item) {
      await this.removePersonalLoc({
        idPersonal: item.id_personal,
        idPersonalLoc: item.idPersonalLoc,
        payload: {},
      })
      this.$store.dispatch('armeria/fetchPersonalArmas')
      this.$store.dispatch('dialog/closeDialog')
    },

    async generarConstanciaNoAdeudo(personal) {
      const area = personal.nombreDependencia && personal.nombreDependencia ? personal.nombreDependencia : ''
      const doc = new ConstanciaNoAdeudoArmeria({
        nombre: personal.nombreCompleto,
        area: area,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ConstanciaNoAdeudo_${personal.nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },

    async generarResguardoArmamentoMuniciones(personal) {
      await this.fetchArmasPersonal(personal.id_personal)
      const fechaHoy = moment().format('YYYY-MM-DD')
      const doc = new ResguardoArmamentoMuniciones({
        nombre: personal.nombreCompleto,
        cuip: personal.CUIP || '',
        fecha: fechaHoy,
        armas: this.armas.map((arma) => arma.Arma),
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ResguardoArmamentoMuniciones_${personal.nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
  created() {
    this.$store.dispatch('armeria/fetchPersonalArmas')
  },
}
</script>
